export const setActiveInterval = (callback, interval) => {
  return setInterval(() => {
    if (!document.hidden) {
      callback()
    }
  }, interval)
}
